import { render, staticRenderFns } from "./PopupTop.vue?vue&type=template&id=3a90fd5c&scoped=true&"
import script from "./PopupTop.vue?vue&type=script&lang=js&"
export * from "./PopupTop.vue?vue&type=script&lang=js&"
import style0 from "./PopupTop.vue?vue&type=style&index=0&id=3a90fd5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a90fd5c",
  null
  
)

export default component.exports